let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cU9ce")).then(() => parcelRequire('7ZWch'));